package com.essntl.features.qbauth.domain.model

data class QbAuthModel(
    val id: String,
    val createdAt: String,
    val accessToken: String?,
    val refreshToken: String?,
    val expiresAt: String?,
    val updatedAt: String?,
)
